import React, { FC } from "react";

import MarkerShape from "@mapmycustomers/shared/enum/MarkerShape";
import { ShapeItemType } from "@mapmycustomers/shared/types/map/PinLegend";

import CustomShapes from "./CustomShapes";
import styles from "./ShapeThemeField.module.scss";

export interface ShapeThemeFieldProps {
  defaultShape: MarkerShape;
  onChange?: (shapes: ShapeItemType[]) => void;
  onDefaultShapeChange?: (color: MarkerShape) => void;
  shapes: ShapeItemType[];
}

const ShapeThemeField: FC<ShapeThemeFieldProps> = ({
  defaultShape,
  onChange,
  onDefaultShapeChange,
  shapes,
}) => {
  return (
    <div className={styles.container}>
      <CustomShapes
        defaultShape={defaultShape}
        onChange={onChange}
        onDefaultShapeChange={onDefaultShapeChange}
        shapes={shapes}
      />
    </div>
  );
};

export default ShapeThemeField;
